import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import { ButtonContained } from '../components/app-button/button'
import cx from 'classnames'
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import CustomizeAll from '../components/сustomize-all/'
import Checkbox from '@material-ui/core/Checkbox'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 410,
    width: '100%',
    marginLeft: 74,
    textAlign: 'center',
  },
  paragraph: {
    marginBottom: 32,
  },
  subtitle: {
    marginBottom: 16,
  },
  paymentOffer: {
    display: 'flex',
    marginBottom: 24,
  },
  paymentOfferLink: {
    color: '#000000',
    textDecoration: 'underline',
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Google Analytics \nнастроен',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class CardComplete extends Component {
  state = {
    activeStep: 7,
    visited: window.state.visited,
  }

  componentDidMount() {
    // if (!this.state.visited) {
      // Отправка события привязки карты
      // window.dataLayer.push({'cd ..
    // event': 'cardtied'})
    // }
  }
  handleClick(classes){
    window.dataLayer.push({ event: 'StartTrial'})
    console.log(12);
  }
  render() {
    const { classes } = this.props
    const steps = getSteps()

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />
          <div style={{ width: 200 }}>
            <AppStepper activeStep={this.state.activeStep} steps={steps} />
          </div>
          <div className={classes.wizardContent} style={{ paddingTop: 50 }}>
            <Typography
              component="p"
              variant="body1"
              className={classes.paragraph}
            >
              <span style={{ whiteSpace: 'pre' }}>
                {`У вас есть 14 совершенно бесплатных дней, \nчтобы убедиться, что ROMI center – \nэто то, что вам нужно :)`}
              </span>
            </Typography>
            <ButtonContained
              style={{
                height: 60,
                fontSize: 16,
                width: '100%',
                padding: 0,
              }}
              type="submit"
              color="primary"
              text="Начать использовать ROMI center!"
              onClick={() => this.handleClick(classes)}
              href="/wizard/finish"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(CardComplete)
